import { z } from "zod";

export const bulkTenderDocumentFormDataSchema = z.object({
	labelSize: z.object({
		displayName: z.string().min(1),
		labelSize: z.string().min(1),
	}),
	labelsPerShipment: z.number().int().min(1).max(999),
	additionalDetails: z.string().max(150),
});

export const bulkTenderDocumentsRequestSchema = z.object({
	quoteIds: z.array(z.number().int().positive()).min(1).max(500),
	formData: bulkTenderDocumentFormDataSchema,
});

export type BulkTenderDocumentFormData = z.infer<
	typeof bulkTenderDocumentFormDataSchema
>;
export type BulkTenderDocumentsRequest = z.infer<
	typeof bulkTenderDocumentsRequestSchema
>;
